module.exports = __webpack_public_path__ + "img/rank1.c06423d3.svg";